import React, { useEffect, useState } from "react";
 
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";

import Loading from "../../../components/Loading";
import TurnTabComponent from "../../../components/ScheduleConfig/TurnTabComponent";
import { formattedDate, serverDate } from "../../../utils/date";

import useStyles from "./styles";
import { getDataStorage } from "../../../utils/filterManagementDataStore";

const TurnTab = ({
  blocks,
  branches,
  filter,
  setFilter,
  loadBlocks,
  deleteBlock,
  addBlock,
  updateBlock,
  subRoutes,
  turnError,
  clearError,
  timeBlocksLoading,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();

  const removeItem = (data) => {
    const date = formattedDate(filter.turnDate) || serverDate(getDataStorage('turn_config_selectedTurnDate'));
    deleteBlock({ id: data.id, date: date });
  };
  const addItem = (turnData) => addBlock(turnData);
  const updateItem = (turnData) => updateBlock(turnData);
  const getNotifications = () => getNotificationsFromSchedConfigAsync();

  const [blocksState, setBlocksState] = useState([]);

  useEffect(() => {
    setBlocksState(blocks);
  }, [blocks]);

  useEffect(() => {
    const branchId = filter.turn_branch || getDataStorage('turn_config_checkSingleBranch')?.value;
    const turnDate = filter.turnDate || getDataStorage('turn_config_selectedTurnDate');

    if (branchId && turnDate) {
      const handleDate = moment(turnDate).format('YYYY-MM-DD');

      loadBlocks({
        branchId,
        date: handleDate,
        getAllTimeBlocks: false,
      });
    } else {
      setBlocksState([]);
    }

  }, [loadBlocks, filter.turn_branch, filter.turnDate]);

  return (
    <div className={classes.root}>
      {timeBlocksLoading && <Loading />}
      <TurnTabComponent
        subRoutes={subRoutes}
        blocks={blocksState}
        onDeleteItem={removeItem}
        onAddItem={addItem}
        onUpdateItem={updateItem}
        branches={branches}
        filter={filter}
        setFilter={setFilter}
        loadBlocks={loadBlocks}
        turnError={turnError}
        clearError={clearError}
        getNotificationsFromSchedConfigAsync={getNotifications}
      />
    </div>
  );
};


const mapState = ({ timeBlocks: { blocks, loading, error }, notifications }) => ({
  blocks,
  timeBlocksLoading: loading,
  turnError: error,
  notifications: notifications.allNotifications
});
const mapDispatch = (dispatch) => ({
  loadBlocks: (payload) => dispatch.timeBlocks.loadAsync(payload),
  addBlock: (id) => dispatch.timeBlocks.addAsync(id),
  updateBlock: (id) => dispatch.timeBlocks.updateAsync(id),
  deleteBlock: (payload) => dispatch.timeBlocks.deleteAsync(payload),
  clearError: (payload) => dispatch.timeBlocks.clearError(payload),
  getNotificationsFromSchedConfigAsync: () => dispatch.notifications.getNotificationsFromSchedConfigAsync()
});

TurnTab.propTypes = {
  blocks: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  loadBlocks: PropTypes.func.isRequired,
  deleteBlock: PropTypes.func.isRequired,
  updateBlock: PropTypes.func.isRequired,
  addBlock: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  timeBlocksLoading: PropTypes.bool.isRequired,
  turnError: PropTypes.object,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default connect(mapState, mapDispatch)(TurnTab);
